import React from "react";
import { usePlacesAutocomplete } from "Hooks";
import { Autocomplete, AutocompleteValue, BaseAutocompleteProps } from "./Autocomplete";
import usePlaceGeocoder from "Services/Geocoder";
import { ILocationViewModel, IPlacePredictionViewModel } from "Services/API/API";


export interface PlacesAutocompleteProps extends BaseAutocompleteProps {
   value: AutocompleteValue,
   onChange: (value: AutocompleteValue) => void,
   isInvalid?: boolean,
   validationMessage?: string,
   onItemSelected?: (option: ILocationViewModel) => void;
}

export const PlacesAutocomplete: React.FC<PlacesAutocompleteProps> = function ({ onItemSelected, ...baseProps }) {
   const withUseAutocompleteOptions = usePlacesAutocomplete(true);
   const geocoder = usePlaceGeocoder();

   const onSelected = async (option: IPlacePredictionViewModel) => {
      if (onItemSelected && option.placeId) {
         const result = await geocoder.getPlaceDetails(option.placeId);

         if (status == "OK" && result) {
            onItemSelected(result);
         }
      }
   }

   return (<Autocomplete<IPlacePredictionViewModel>
      onItemSelected={onSelected}
      itemToString={(item) => item?.text ?? ""}
      {...baseProps}
      {...withUseAutocompleteOptions}
   />);
}